import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #13: rendering React components with canvas",
  "description": "",
  "published": "2016-06-28T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-13-rendering-react-components-with-canvas/swizec/6784"],
  "categories": "coding, d3.js, d3js, Front End, js, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. It’s shorter than 500 words, and there are pictures! You can follow my channel `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat. Come hang out.`}</em>{` ?`}</p>
    <p>{`This Sunday was all about rendering React components with canvas and smoothly animating 10k+ circles.`}</p>
    <p>{`We did it! Well, the canvas part. The smooth animation part … not so much. Turns out that part’s hard.`}</p>
    <p>{`It all started with some tedious coding to update the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/react-particles-experiment"
      }}>{`React particles experiment`}</a>{` to D3 v4. Some idiot (me) had had the bright idea of changing that and not finishing the transition.`}</p>
    <p>{`With the release candidate version of D3v4, importing the entire library no longer works. From now on, you have to do something like `}<inlineCode parentName="p">{`import { randomNormal } from 'd3'`}</inlineCode>{` to get specific bits and pieces. This is tedious, but it produces smaller bundles in the end. All in all, it’s better this way.`}</p>
    <p>{`Our slow implementation was back. `}{`\\`}{`o/`}</p>
    <p>{`[`}{`embed]`}<a parentName="p" {...{
        "href": "http://imgur.com/w7nSJGI"
      }}>{`http://imgur.com/w7nSJGI`}</a></p>
    <p>{`Then we turned to `}<a parentName="p" {...{
        "href": "https://github.com/lavrton/react-konva"
      }}>{`react-konva`}</a>{`, `}<em parentName="p">{`“a JavaScript library for drawing complex canvas graphics using React.”`}</em>{` In theory, we should be able to render our particles using HTML5 canvas without changing our code too much.`}</p>
    <p>{`It’s based on the `}<a parentName="p" {...{
        "href": "http://konvajs.github.io/"
      }}>{`Konva`}</a>{` library, which looks like a sort of D3 for canvas. It gives you a bunch of useful abstractions to make 2d graphicsing easier.`}</p>
    <p>{`To my surprise, the conversion `}<em parentName="p">{`was`}</em>{` simple.`}</p>
    <p>{`We had to change our main render method to use a Konva `}<inlineCode parentName="p">{`Stage`}</inlineCode>{` instead of an `}<inlineCode parentName="p">{`<svg>`}</inlineCode>{` node:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`<stage width={this.props.svgWidth} height={this.props.svgHeight}>
  <layer>
    <particles particles={this.props.particles}></particles>
  </layer>
</stage>
`}</code></pre>
    <p>{`We also wrapped it in a big `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` to help D3 detect the mouse events we need for particle generation. Yes, we could have moved away from D3 for those, but it was already coded up, so why change?`}</p>
    <p>{`We had to change the `}<inlineCode parentName="p">{`Particles`}</inlineCode>{` render method to use Konva’s `}<inlineCode parentName="p">{`Circle`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`<group>
   {particles.map(particle =>
      <circle radius="1.8" x={particle.x} y={particle.y} key={particle.id} fill="black">
   )}
</circle></group>
`}</code></pre>
    <p>{`Things Just Worked™. Kind of. Our animation looked less than smooth, even with just 200 particles. With a few thousand, it was comically bad.`}</p>
    <p>{`[`}{`embed]`}<a parentName="p" {...{
        "href": "http://imgur.com/X9a7hzp"
      }}>{`http://imgur.com/X9a7hzp`}</a></p>
    <p>{`Not cool, React. Not cool. Canvas is supposed to be super fast! Maybe this `}<em parentName="p">{`is`}</em>{` a bit faster than the SVG approach? It’s hard to tell.`}</p>
    <p>{`We did some profiling and discovered that calculating a new frame takes only 7 milliseconds. Flushing those changes to React components … heh … that took anywhere from 200ms to 980ms.`}</p>
    <p>{`?`}</p>
    <p>{`Yikes.`}</p>
    <p>{`The culprit seems to be a function called `}<inlineCode parentName="p">{`updateChildren`}</inlineCode>{` deep in the bowels of React.`}</p>
    <p>{`We’ll find a workaround on Sunday the 10th of July. There are several promising venues to explore, anything from using better Konva components (FastLayer is a thing) to avoiding prop updates as the driver of our animation. Somehow. We’ll figure it out.`}</p>
    <p>{`See you next time.`}</p>
    <p>{`PS: the edited and improved versions of these videos are becoming a video course. Readers of the engineer package of `}<a parentName="p" {...{
        "href": "http://swizec.com/reactd3js/"
      }}>{`React+d3js ES6`}</a>{` get the video course for free when it’s ready.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      